import { of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import * as Actions from './carrier-sharing.actions';
import * as CarrierSharingApi from './carrier-sharing.api';
import Global from '../../store/global-selectors';

export const getSharedServices = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.GET_SHARED_SERVICES),
    mergeMap((action) => {
      const { fulfillmentPlanId } = action;
      const state = getState();

      const storedFulfillmentPlanId = Global.selectCarrierSharingfulfillmentPlanId(state);
      if (storedFulfillmentPlanId === fulfillmentPlanId) {
        const data = {
          serviceGroups: Global.selectCarrierSharingserviceGroups(state),
          required: Global.selectCarrierSharingisRequired(state),
        };
        return of(Actions.getSharedServicesSuccess(data, fulfillmentPlanId));
      }

      return CarrierSharingApi.getSharedServices(fulfillmentPlanId).pipe(
        mergeMap((data) => {
          return of(Actions.getSharedServicesSuccess(data, fulfillmentPlanId));
        }),
        catchError((payload) => {
          const errors = (payload?.response?.data?.Errors || []).map((error) => error.Message);
          return of(Actions.getSharedServicesError(errors));
        }),
      );
    }),
  );
};
